import { createApiRef } from '@backstage/core-plugin-api';

export const FEEDBACK_TYPES = ['new_idea', 'bug', 'enhancement'] as const;
export type FeedbackType = (typeof FEEDBACK_TYPES)[number];

export const FEEDBACK_PRIORITIES = [
  'nice_to_have',
  'important',
  'critical',
] as const;
export type FeedbackPriority = (typeof FEEDBACK_PRIORITIES)[number];

/** Image types the backend accepts as screenshots. */
export const SCREENSHOT_CONTENT_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
] as const;
/** Most screenshots on one submission (mirrors the backend). */
export const SCREENSHOT_MAX_FILES = 10;
/** Largest single screenshot, in bytes (mirrors the backend). */
export const SCREENSHOT_MAX_BYTES = 5 * 1024 * 1024;

export interface FeedbackSubmission {
  email: string;
  type: FeedbackType;
  priority: FeedbackPriority;
  feature: string;
  feedback: string;
  /** Page the developer was on; attached automatically. */
  pageUrl?: string;
  /** From the identity API; the backend records the verified entity ref itself. */
  authorName?: string;
  /** Screen captures; uploaded as attachments of the work item. */
  screenshots?: File[];
}

/** The Azure DevOps work item the submission became. */
export interface WorkItemRef {
  id: number;
  type: 'Task';
  url: string;
}

export interface FeedbackResult {
  ok: true;
  submittedAt: string;
  workItem: WorkItemRef;
  /** False when the work item exists but the Teams card could not be posted. */
  teamsDelivered: boolean;
}

export interface FeedbackApi {
  submit(submission: FeedbackSubmission): Promise<FeedbackResult>;
}

export const feedbackApiRef = createApiRef<FeedbackApi>({
  id: 'plugin.feedback.api',
});
